import { render, staticRenderFns } from "./artisanWithdraw.vue?vue&type=template&id=b88b7dc8&scoped=true&"
import script from "./artisanWithdraw.vue?vue&type=script&lang=js&"
export * from "./artisanWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./artisanWithdraw.vue?vue&type=style&index=0&id=b88b7dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b7dc8",
  null
  
)

export default component.exports